/* eslint-disable react-hooks/exhaustive-deps */

import * as Icon from 'base/ui/components/Icons';

import { Form, Radio, Spin, message } from 'antd';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { catalogPresenter, catalogStore, stockPresenter, stockStore, userStore } from 'stores/root_store';

import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomBreadcrumb from 'base/ui/components/CustomBreadcrumb';
import CustomInput from 'base/ui/components/CustomInput';
import CustomSelect from 'base/ui/components/CustomSelect';
import { usePermission } from 'hooks/usePermission';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { DataCatalog } from 'services/RawData/catalog_services';
import { SYSTEM_TITLE } from 'utils/constants';
import { removeEmptyValues } from 'utils/transformHelper';

const createAddUpdateStock = () => {
  return observer(() => {
    const { t } = useTranslation();

    // Get data params from url
    const { id: idParams } = useParams();
    // Check id để đặt tên trang
    let pageTitle = '';

    // Nếu có id là chỉnh sửa (xem chi tiết)
    if (idParams) {
      // Kiểm tra phân quyền
      usePermission('EDIT'); // Kiểm tra xem được quyền truy cập vào trang
      pageTitle = t('page-title.update');
      document.title = pageTitle + ' - ' + SYSTEM_TITLE;
    } else {
      // Kiểm tra phân quyền
      usePermission('CREATE');
      pageTitle = t('page-title.create');
      document.title = pageTitle + ' - ' + SYSTEM_TITLE;
    }

    const navigate = useNavigate();
    //==========================STATE===================//
    // Loading
    const [loading, setLoading] = useState(false);
    const [listStockType, setListStockType] = useState<DataCatalog[]>([]);

    // Check button save and save continue
    let isSaveAndContinue = false;
    const [form] = Form.useForm();

    //==========================FUNCTION===================//

    // Call api detail stock
    const getDetailStock = async (stockId: string) => {
      await stockPresenter.getDetailStock(stockStore, stockId);
      if (stockStore.detailStockResponse.isSuccess) {
        form.setFieldsValue(stockStore.detailStockResponse.data);
        // Map stockType from detail to catalogCode select field for edit mode
        if (stockStore.detailStockResponse.data?.stockType) {
          form.setFieldsValue({ catalogCode: (stockStore.detailStockResponse.data as any).stockType });
        }

        setLoading(false);
      } else {
        navigate('/MasterData/Warehouse');
      }
    };

    // Lấy danh sách loại kho (StockType) từ catalog
    const getListStockType = async () => {
      await catalogPresenter.searchDropdownCatalog(catalogStore, 'StockType');
      if (catalogStore.searchDropdownCatalogResponse.isSuccess) {
        setListStockType(catalogStore.searchDropdownCatalogResponse.data);
        // Set default value for create mode
        if (!idParams) {
          const first = catalogStore.searchDropdownCatalogResponse.data?.[0];
          if (first && !form.getFieldValue('catalogCode')) {
            form.setFieldsValue({ catalogCode: first.catalogCode });
          }
        }
      }
    };

    // Call api first access
    useEffect(() => {
      if (idParams) {
        getDetailStock(idParams);
      }
      getListStockType();
    }, []);

    // Handle create stock
    const onFinish = async (values: any) => {
      setLoading(true);
      removeEmptyValues(values);
      if (!idParams) {
        const dataSendApi = {
          ...values,
          stockType: values.catalogCode,
        };
        await stockPresenter.createDetailStock(stockStore, dataSendApi);
        if (stockStore.createDetailStockResponse.isSuccess) {
          message.success(stockStore.createDetailStockResponse.message || t('message.create-success'));

          // Redirect to search page stock (Button Save)
          if (!isSaveAndContinue) {
            navigate('/MasterData/Warehouse');
          } else {
            // Nếu là "Lưu và tiếp tục thêm mới", reset form và set mặc định loại kho là kho đầu tiên
            form.resetFields();
            const firstStockType = listStockType?.[0];
            if (firstStockType) {
              form.setFieldsValue({
                catalogCode: firstStockType.catalogCode,
                actived: true,
                isValueManagement: true,
              });
            } else {
              // Nếu không có kho nào, set lại initialValue
              form.setFieldsValue(initialValue);
            }
          }
        } else if (stockStore.createDetailStockResponse.message) {
          message.error(stockStore.createDetailStockResponse.message);
        }
      } else {
        const dataSendApi = {
          ...values,
          stockType: values.catalogCode,
          stockId: idParams,
        };

        // Call api update
        await stockPresenter.updateDetailStock(stockStore, dataSendApi);
        if (stockStore.updateDetailStockResponse.isSuccess) {
          message.success(stockStore.updateDetailStockResponse.message || t('message.update-success'));

          // Redirect to search page routing (Button Save)
          if (!isSaveAndContinue) {
            navigate('/MasterData/Warehouse');
          }
        } else if (stockStore.updateDetailStockResponse.message) {
          message.error(stockStore.updateDetailStockResponse.message);
        }
      }
      setLoading(false);
    };

    // initial value in form
    const initialValue = {
      actived: true,
      isValueManagement: true,
    };

    function ButtonCreateUpdate() {
      return (
        <>
          <CustomButton
            icon={<Icon.Download className="!fill-[#262626]" />}
            htmlType="submit"
            disabled={loading}
            loading={loading}
            onClick={() => {
              isSaveAndContinue = false;
              form.submit();
            }}
          >
            {t('btn.save')}
          </CustomButton>
          <CustomButton
            type="primary"
            icon={<Icon.Download />}
            disabled={loading}
            loading={loading}
            onClick={() => {
              isSaveAndContinue = true;
              form.submit();
            }}
          >
            {idParams ? t('btn.save-update') : t('btn.save-continue-create')}
          </CustomButton>
        </>
      );
    }
    return (
      <>
        <div className="flex flex-col h-full">
          <CustomBreadcrumb
            pagetitle={[
              {
                title: t('masterdata.stock.title'),
                link: '/MasterData/Warehouse',
              },
              {
                title: pageTitle,
                link: idParams ? `/MasterData/Warehouse/${idParams}` : '/MasterData/Warehouse/create',
              },
            ]}
            extra={
              <div className="custom__mobile--save flex space-x-2">
                {!idParams && userStore.userPermission?.includes('CREATE') ? <ButtonCreateUpdate /> : null}
                {idParams && userStore.userPermission?.includes('EDIT') ? <ButtonCreateUpdate /> : null}
              </div>
            }
          />
          <BoxContainer fullHeight>
            {/* Form create/update */}
            <Spin spinning={loading}>
              <SearchForm initialValues={idParams ? {} : initialValue} form={form} onFinish={onFinish}>
                {/* Mã kho */}
                <SearchItem
                  label={t('masterdata.stock.stock-code')}
                  name="stockCode"
                  rules={[
                    { required: true, message: `${t('message.required-input')} ${t('masterdata.stock.stock-code')}` },
                  ]}
                >
                  <CustomInput disabled={idParams ? true : false} />
                </SearchItem>
                {/* Tên kho */}
                <SearchItem label={t('masterdata.stock.stock-name')} name="stockName" rules={[
                  { required: true, message: `${t('message.required-input')} ${t('masterdata.stock.stock-name')}` },
                ]}>
                  <CustomInput />
                </SearchItem>
                {/* Loại kho */}
                <SearchItem label={t('masterdata.stock.stock-type')} name="catalogCode" rules={[
                  { required: true, message: `${t('message.required-input')} ${t('masterdata.stock.stock-type')}` },
                ]}>
                  <CustomSelect
                    options={listStockType}
                    fieldNames={{ label: 'catalogName', value: 'catalogCode' }}
                    allowClear
                  />
                </SearchItem>
                {/* Trạng thái */}
                {idParams && (
                  <SearchItem className="m-0 mb-2" name={'actived'} label={t('masterdata.stock.status')}>
                    <Radio.Group>
                      <Radio value={true}>{t('radio-btn.active')}</Radio>
                      <Radio value={false}>{t('radio-btn.in-active')}</Radio>
                    </Radio.Group>
                  </SearchItem>
                )}
              </SearchForm>
            </Spin>
          </BoxContainer>
        </div>
      </>
    );
  });
};

export default createAddUpdateStock;
